import React from "react";
import NotificationsRouter from './Notification/Router';
export { getFields, getReplyFields } from './Notification/Router';

export default function NotificationSupervisorRouter(props) {
    return (
        <NotificationsRouter {...props} mode='SUPPLIER_SUPPLIER' />
    );
};
